<template>
  <div class="advantages-section">
    <z-title size="large" color="major" align="center" class="advantages__title">
      Veja o comparativo de alunos com e sem o Quero Pago
    </z-title>
    <z-card class="advantages__comparison-wrapper" size="large">
      <table class="advantages__comparison-table">
        <thead>
          <th class="comparison-header__item">
            <z-title size="extra-small" color="minor">
              Sem Quero Pago
            </z-title>
          </th>
          <th class="comparison-header__item">
            <z-title size="extra-small" color="info">
              Com Quero Pago
            </z-title>
          </th>
        </thead>
        <tbody>
          <tr v-for="(comparison, index) in comparisons" :key="index">
            <td
              class="comparison-table__item"
              :class="{ 'comparison-table__item--last': isLastComparison(index) }"
            >
              <div class="comparison-item__content">
                <z-icon
                  :icon="['fas', 'times-circle']"
                  color="danger"
                  size="large"
                  class="comparison-item__content-icon"
                />
                <z-text tag="div" size="medium" color="major">
                  {{ comparison.without }}
                </z-text>
              </div>
            </td>
            <td
              class="comparison-table__item"
              :class="{ 'comparison-table__item--last': isLastComparison(index) }"
            >
              <div class="comparison-item__content">
                <z-icon
                  :icon="['fas', 'check-circle']"
                  color="success"
                  size="large"
                  class="comparison-item__content-icon"
                />
                <z-text tag="div" size="medium" color="major">
                  {{ comparison.with }}
                </z-text>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="advantages__comparison-list">
        <z-title size="extra-small" color="minor" align="center" class="comparison-list__title">
          Sem Quero Pago
        </z-title>

        <template v-for="(comparison, index) in comparisons">
          <z-divider v-if="index != 0" :key="`${index}lwithoutdivider`" />
          <div class="comparison-list__item" :key="`${index}lwithoutcontent`">
            <z-icon
              :icon="['fas', 'times-circle']"
              color="danger"
              size="large"
              class="comparison-list__content-icon"
            />
            <z-text tag="div" size="medium" color="major">
              {{ comparison.without }}
            </z-text>
          </div>
        </template>

        <z-title
          size="extra-small"
          color="info"
          align="center"
          class="comparison-list__title comparison-list__title--with"
        >
          Com Quero Pago
        </z-title>

        <template v-for="(comparison, index) in comparisons">
          <z-divider v-if="index != 0" :key="`${index}lwithdivider`" />
          <div class="comparison-list__item" :key="`${index}lwithcontent`">
            <z-icon
              :icon="['fas', 'check-circle']"
              color="success"
              size="large"
              class="comparison-list__content-icon"
            />
            <z-text tag="div" size="medium" color="major">
              {{ comparison.with }}
            </z-text>
          </div>
        </template>
      </div>
    </z-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      comparisons: [
        {
          without: 'Problemas no pagamento? Renegociar? Bora encarar a fila da secretaria.',
          with: 'Você resolve tudo por aqui e ainda pode ficar de boa no sofá.',
        },
        {
          without: 'Às vezes, não rola escolher a forma de pagamento.',
          with: 'Quer pagar em boleto? Dá! Quer usar o cartão de crédito? Dá também!',
        },
        {
          without: 'Quer falar? Tem que ir até a facul ou ligar.',
          with: 'Se rolar uma dúvida, é só nos chamar no Whatsapp que a gente bate um papo.',
        },
      ],
    };
  },
  methods: {
    isLastComparison(index) {
      return index + 1 === this.comparisons.length;
    },
  },
};
</script>

<style scoped lang="scss">
.advantages-section {
  background-color: var(--color-background-primary);
  padding: var(--space-extra-colossal) var(--space-medium);
  width: 100%;

  @media screen and (max-width: $screen-md-max) {
    padding: var(--space-jumbo) var(--space-medium);
  }
}

.advantages__title {
  margin-bottom: var(--space-jumbo);
  position: relative;
  z-index: 1;
}

.advantages__comparison-wrapper {
  float: none;
  margin: 0 auto;
  position: relative;
  width: 810px;
  z-index: 1;

  @media screen and (max-width: $screen-md-max) {
    width: 100%;
  }
}

.advantages__comparison-table {
  border-collapse: collapse;
  width: 100%;

  @media screen and (max-width: $screen-md-max) {
    display: none;
  }
}

.advantages__comparison-list {
  display: none;
  width: 100%;

  @media screen and (max-width: $screen-md-max) {
    display: block;
  }
}

.comparison-header__item {
  padding-bottom: var(--space-medium);

  &:last-child {
    padding-left: var(--space-small);
  }
}

.comparison-table__item {
  border-bottom: 2px solid var(--color-gray-050);
  padding-bottom: var(--space-medium);
  padding-top: var(--space-medium);
  width: 50%;

  &:first-child {
    padding-right: var(--space-small);
  }

  &:last-child {
    padding-left: var(--space-small);
  }
}

.comparison-table__item--last {
  border-bottom: none;
  padding-bottom: 0;
}

.comparison-item__content {
  align-items: center;
  display: inline-flex;
}

.comparison-item__content-icon {
  margin-right: var(--space-medium);
}

.comparison-list__item {
  align-items: center;
  display: inline-flex;
  padding-top: var(--space-medium);

  &:not(:last-child) {
    padding-bottom: var(--space-medium);
  }
}

.comparison-list__content-icon {
  margin-right: var(--space-medium);
}

.comparison-list__title {
  padding-bottom: var(--space-medium);
}

.comparison-list__title--with {
  padding-top: var(--space-jumbo);
}
</style>
